import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export const ContactPage = () => {
  return (
    <div className="min-h-screen pt-32 pb-20" data-testid="contact-page">
      {/* Header */}
      <section className="py-12 sm:py-16 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="max-w-3xl">
            <h1 className="font-heading font-black text-5xl sm:text-6xl lg:text-7xl text-amber-500 uppercase mb-4">
              Pro Painting
            </h1>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white uppercase mb-4">
              Contact <span className="text-amber-500">Us</span>
            </h2>
            <p className="text-slate-400 text-lg">
              Ready to transform your space? Get in touch for a free estimate or to discuss your project.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 sm:py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Contact Info */}
            <div className="lg:col-span-1 space-y-8">
              <div>
                <h2 className="font-heading font-bold text-2xl text-white uppercase mb-6">Get In Touch</h2>
                
                <div className="space-y-6">
                  <a
                    href="tel:+18303270136"
                    className="flex items-start gap-4 group"
                    data-testid="contact-phone"
                  >
                    <div className="w-12 h-12 bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/20 transition-colors">
                      <Phone className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-500 text-sm uppercase tracking-wider mb-1">Phone</p>
                      <p className="text-white text-lg font-semibold group-hover:text-amber-500 transition-colors">(830) 327-0136</p>
                    </div>
                  </a>

                  <a
                    href="mailto:matthew@propainting.cloud"
                    className="flex items-start gap-4 group"
                    data-testid="contact-email"
                  >
                    <div className="w-12 h-12 bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/20 transition-colors">
                      <Mail className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-500 text-sm uppercase tracking-wider mb-1">Email</p>
                      <p className="text-white text-lg font-semibold group-hover:text-amber-500 transition-colors">matthew@propainting.cloud</p>
                    </div>
                  </a>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-500 text-sm uppercase tracking-wider mb-1">Address</p>
                      <p className="text-white font-semibold">493 N Market St</p>
                      <p className="text-slate-400">New Braunfels, TX 78130</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0">
                      <Clock className="w-5 h-5 text-amber-500" />
                    </div>
                    <div>
                      <p className="text-slate-500 text-sm uppercase tracking-wider mb-1">Business Hours</p>
                      <p className="text-white font-semibold">Mon - Fri: 8:00 AM - 5:00 PM</p>
                      <p className="text-slate-400">Sat - Sun: Closed</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-slate-900 border border-slate-800 p-6">
                <p className="text-slate-500 text-sm text-center">
                  {/* ADMIN NOTE: Replace with Google Maps embed iframe */}
                  Map embed placeholder - Add your Google Maps embed code here
                </p>
              </div>
            </div>

            {/* Contact Form - GoHighLevel Embed */}
            <div className="lg:col-span-2">
              <div className="bg-slate-900 border border-slate-800 p-6 sm:p-8">
                <h2 className="font-heading font-bold text-2xl text-white uppercase mb-2">Request a Free Estimate</h2>
                <p className="text-amber-500 font-bold text-lg mb-6">Pro Painting - New Braunfels, TX</p>

                <iframe
                    src="https://links.roxvegas.cloud/widget/form/sa1CzRTLq9iUSSf9SnHJ"
                    style={{width: '100%', height: '641px', border: 'none', borderRadius: '3px'}}
                    id="inline-sa1CzRTLq9iUSSf9SnHJ" 
                    data-layout="{'id':'INLINE'}"
                    data-trigger-type="alwaysShow"
                    data-trigger-value=""
                    data-activation-type="alwaysActivated"
                    data-activation-value=""
                    data-deactivation-type="neverDeactivate"
                    data-deactivation-value=""
                    data-form-name="Pro_Painting_OFS"
                    data-height="641"
                    data-layout-iframe-id="inline-sa1CzRTLq9iUSSf9SnHJ"
                    data-form-id="sa1CzRTLq9iUSSf9SnHJ"
                    title="Pro_Painting_OFS"
                >
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
